import axios from 'axios';
import { GET_USER_LOGS_URL, get_headers } from '@/utils/constants/constants.js';

export default {
  props: {
    user_id: {
      type: Number,
      required: true,
    }
  },
  data() {
    return () => ({ user_activity_logs: [], loading: false, error: null });
  },
  watch: {
    user_id: {
      immediate: true,
      handler() {
        this.fetch_user_activity();
      }
    }
  },
  methods: {
    async fetch_user_activity() {
      if (!this.user_id) {
        this.error = 'No user ID provided';
        return;
      }
    
      this.loading = true;
      this.error = null;
    
      const payload = { user_id: this.user_id };
    
      try {
        const response = await axios.post(GET_USER_LOGS_URL, payload, {
          headers: get_headers(),
        });
    
        let response_data = typeof response.data === 'string'
          ? JSON.parse(response.data)
          : response.data;
    
        if (response_data && response_data.data && Array.isArray(response_data.data)) {
          response_data = response_data.data;
        }
    
        if (Array.isArray(response_data)) {
          this.user_activity_logs = response_data.map(log => ({
            id: log.id,
            user_id: log.user_id,
            message: log.message,
            date: this.format_date(log.date_created),
            time: this.format_time(log.date_created),
          }));
        } else {
          this.user_activity_logs = [];
        }
      } catch (error) {
        this.error = this.get_error_message(error);
        this.user_activity_logs = [];
      } finally {
        this.loading = false;
      }
    },
    format_date(time_stamp) {
      return new Date(time_stamp).toLocaleDateString();
    },
    format_time(time_stamp) {
      return new Date(time_stamp).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    get_error_message(error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data?.message || 'Failed to fetch logs';
      }
      return 'An unexpected error occurred.';
    }
  },
  mounted() {
    if (typeof this.user_id !== "undefined") {
      this.fetch_user_activity();
    }
  }
};
